import { ReactNode, useEffect, useState } from 'react';

import { NewsCard } from '@frontend-libs/portal';

import { NewsModel } from '@portal-clients/news';

import { BottomDrawer } from '../bottom-drawer.component';
import { NewsCarousel } from './news-carousel.component';
import { NewsDrawerContent } from './news-drawer-content.component';

export interface NewsCardCarouselProps {
  newsList: NewsModel[];
  portalId: string;
  maxItems: number;
  singleCardWrapper?: (card: ReactNode) => ReactNode;
}

export const NewsCardCarousel = ({
  newsList,
  portalId,
  maxItems,
  singleCardWrapper,
}: NewsCardCarouselProps) => {
  const [selectedNews, setSelectedNews] = useState<NewsModel | undefined>(
    undefined,
  );
  const [showNewsDetails, setShowNewsDetails] = useState(false);

  useEffect(() => {
    if (selectedNews) {
      setShowNewsDetails(true);
    }
  }, [selectedNews]);

  const renderSingleCard = () => {
    const card = (
      <NewsCard
        title={newsList[0]!.title}
        description={newsList[0]!.description}
        publishDate={newsList[0]!.publishDate}
        portalId={portalId}
        imageUrl={
          newsList[0]!.image
            ? newsList[0]!.image.imageUrl
            : newsList[0]!.imageUrl
        }
        imageAltText={newsList[0]!.image?.altText}
        onClick={() => setSelectedNews(newsList[0])}
      />
    );

    return singleCardWrapper ? singleCardWrapper(card) : card;
  };

  return (
    <>
      {newsList.length === 1 && renderSingleCard()}

      {newsList.length > 1 && (
        <NewsCarousel
          portalId={portalId}
          newsList={newsList.slice(0, maxItems)}
          onClick={(id) => setSelectedNews(newsList.find((n) => n.id === id))}
        />
      )}

      {!!selectedNews && (
        <BottomDrawer
          openState={showNewsDetails}
          toggleDrawer={() => setShowNewsDetails(false)}
          onCloseTransitionFinished={() => setSelectedNews(undefined)}
          content={<NewsDrawerContent news={selectedNews} />}
        />
      )}
    </>
  );
};
